<!--创建节点-->
<template>
  <div class="createNodeBody">
    <div class="Files-top">
      <div class="ic-left">
        <span>节点列表(至少需要有一个节点)</span>
      </div>
      <div class="btns">
        <el-button type="primary" plain @click="pickerWorkFlow_fn" v-if="nowIsFlag"
          class="last-el-button">从工作流中导入</el-button>
      </div>
    </div>

    <!-- <scheduleAxis
      ref="scheduleAxisBean"
      :dataList="nodeList"
      @addItem="addNode"
      @deleteItem="nodeList.remove($event)"
      @checkItem="checkItem($event)"
      @editItem="editNode"
      nameKey="nodeName"
    ></scheduleAxis> -->
    <!-- 进度轴 -->
    <div class="speed-progress">

      <div class="content">
        <el-scrollbar style="width:100%;height:100%">
          <div class="item" v-for="(item,index) in nodeList" :key="index" @click="nodeList_fn(item,index)">
            <div :class="['item-num', {'active':nodeListIndex == index}]">{{index +1}}

              <i class="el-icon-delete" @click.stop="deletePro(index)"></i>

            </div>
            <div :class="['item-name',{'item-name-active':nodeListIndex == index}]">{{item.nodeName}}</div>
            <div class="item-line"></div>

          </div>
        </el-scrollbar>
      </div>
      <div class="add-btn" @click="addNode"><i class="el-icon-plus"></i></div>
    </div>

    <div class="selectNodeValue" v-show="nodeList.length != 0">
      <div class="selectNodeValue-input ">
        <span>节点名称(必填)：</span>
        <el-input v-model="nodeName" placeholder="请输入名称"></el-input>
      </div>
      <div class="selectNodeValue-input input1" style="margin:0px 20px">
        <span>节点类型(必选)：</span>
        <el-select v-model="typeValue" placeholder="请选择">
          <el-option v-for="item in nodeTypeList" :key="item.value" :label="item.name" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="selectNodeValue-input">
        <span>节点负责人(必选)：</span>
        <!-- <p  @click="addUsers" 
            :title="nowNodeUserName"
            style="text-overflow: ellipsis;max-width: 70%;overflow: hidden;white-space: nowrap;"
            class="pickerText"
            >
            {{ nowNodeUserName }}
            </p> -->
        <div class="user-sle" @mouseleave="isUserTree = false">
          <div class="user-text" @click="isUserTree = !isUserTree">
            <span v-if="nowNodeUserName =='请选择负责人'">请选择负责人</span>
            <span v-else style="color:#1a1a1a">{{nowNodeUserName}}</span>
            <img :class="[{'tran-img':isUserTree}]" src="@/assets/arrowb.png" alt="">
          </div>
          <div class="user-tree" :style="{'height':heights+'px'}" v-show="isUserTree" @mouseleave="isUserTree = false">
            <div class="user-tree-con">
              <el-scrollbar style="height:calc(100% - 10px);width: 100%;">
                <el-tree class="filter-tree" :data="departmentData" highlight-current ref="tree" @node-click="nodeClick"
                  auto-expand-parent :props="defaultProps">
                  <template #default="{ node,data }">
                    <span class="custom-tree-node">
                      <img src="../../../../public/static/image/elTree/1.9.png"
                        v-if="data.entityName=='UsePowerUnit'" />
                      <img src="@/assets/unifyImg/user.png" v-else />
                      <span style="margin-left:5px">{{ node.label }}</span>
                    </span>
                  </template>
                </el-tree>
              </el-scrollbar>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- 自定义 -->
    <div class="custom" v-show=" typeValue == 0 && nodeList.length!= 0  ">
      <div class="custom-left">
        <!-- <div class="titles">操作项</div> -->
        <div class="Files-top">
          <div class="ic-left">
            <span>操作项</span>
          </div>
          <div class="btns">
            <el-button type="primary" @click="addItem" class="last-el-button">新增</el-button>
          </div>
        </div>
        <div class="left-list" :style="{'height':heights+'px'}">
          <el-scrollbar style="width:100%;height:100%">
            <div :class="['item', {'active':nowItem == item}]" v-for="(item,index) in itemList" :key="index"
              @click="nowItem = item"><span>{{item.title}}</span>
              <div class="del-img"><i class="el-icon-delete" @click.stop="deleteItem(index)"></i></div>
            </div>

          </el-scrollbar>
        </div>

      </div>
      <div class="custom-right">
        <!-- <div class="titles">操作步骤</div> -->
        <div class="Files-top">
          <div class="ic-left">
            <span>操作步骤</span>
          </div>
          <div class="btns">
            <el-button type="primary" @click="addAction" class="last-el-button">新增</el-button>
          </div>
        </div>
        <el-table :data="actionList" stripe style="width: 100%" :height="heights" @row-click='nowAction_fn'
          highlight-current-row>
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="actionName" label="名称" width="210"> </el-table-column>
          <el-table-column prop="valueTypeName" label="类型" width="210"> </el-table-column>
          <el-table-column prop="content" label="描述" width="210"> </el-table-column>
          <el-table-column label="操作" align="center">
            <template #default="{row}">
              <span class="buttoned_box">
                <i class="el-icon-delete" style="font-size:20px" @click="deleteAction(row)"></i>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="right-btns">
                 <span class="add" @click="addAction">新增</span>
                <span class="del" @click="deleteAction">删除</span>
            </div> -->
      </div>
    </div>
    <!-- 巡检（台账） -->
    <div class="account" v-if="typeValue == 2">
      <div class="account-left">
        <div class="scroll">
          <p>选择台账设备</p>
          <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
          <el-scrollbar style="height:95%;width: 100%;">
            <el-tree :filter-node-method="filterNode" ref="tree" :props="props" :data="archiveTree" show-checkbox
              node-key="id" :default-expand-all="false" :default-expanded-keys="nodeArchives"
              :default-checked-keys="nodeArchives" @check="currentChecked" v-show="nowOrderGroup.name == '巡检'">
              <!-- @check-change="handleCheckChange" -->
              <span slot-scope="{node}">
                <img src="../../../../public/static/image/elTree/1.9.png" style="margin-right: 5px;"
                  v-show="node.data.type=='group'" />
                <img src="../../../../public/static/image/elTree/2.1.png" style="margin-right: 5px;"
                  v-show="node.data.entityName == 'AppEquipmentArchives'" />
                <span>{{node.label }}</span>
              </span>
            </el-tree>

            <el-tree :filter-node-method="filterNode" ref="tree2" :props="props" :data="archiveTree" node-key="id"
              :default-expand-all="false" v-show="nowOrderGroup.name != '巡检'" :default-expanded-keys="[standingBookId]"
              @node-click="checkItem">
              <!-- @check-change="handleCheckChange" -->
              <span slot-scope="{node}">
                <img src="../../../../public/static/image/elTree/1.9.png" style="margin-right: 5px;"
                  v-show="node.data.type=='group'" />
                <img src="../../../../public/static/image/elTree/2.1.png" style="margin-right: 5px;"
                  v-show="node.data.entityName == 'AppEquipmentArchives'" />
                <span>{{node.label }}</span>
              </span>
            </el-tree>

          </el-scrollbar>
        </div>

      </div>
      <div class="account-right" v-show="nowOrderGroup.name != '巡检'">
        <el-table :data="tableData" ref="multipleTable" stripe style="width: 100%" height="100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="name" label="缺陷名称" width="180"> </el-table-column>
          <el-table-column label="缺陷等级">
            <template #default="{row}">
              <span>{{priorityMatch[row.priority]}}</span>
            </template>
          </el-table-column>
          <el-table-column label="缺陷危害">
            <template #default="{row}">
              <span>{{row.harm }}</span>
            </template>
          </el-table-column>
          <el-table-column label="处理建议">
            <template #default="{row}">
              <span>{{row.proposal}}</span>
            </template>
          </el-table-column>

        </el-table>
      </div>
    </div>

  </div>
</template>

<script>
  import resourcesStore from '@/cache/resourcesStore.js';
  import treeSingleSelection from '@/components/module/selection/base/treeSingleSelection.vue';
  import scheduleAxis from '@/components/module/axis/scheduleAxis.vue';
  import singleSelection from '@/components/module/selection/singleSelection.vue';
  import {departmentFindAllUser} from '@/api/order';
  import {findDefectActionList} from "../../../api/abbNewApi"
  export default {
    components: {
      treeSingleSelection,
      scheduleAxis,
      singleSelection
    },
    props: {
      nowFlow: {
        type: Object
      },
      nowOrderGroup: {
        type: Object
      },
      orderStartTime: {
        type: null
      },
      orderEndTime: {
        type: null
      },
      isImport: {
        type: null
      }
    },
    data () {
      return {
        nowNodeUserName: "",
        isUserTree: false,
        defaultProps: {
          children: 'next',
          label: 'name'
        },
        heights: document.getElementById('app').clientHeight-560,//屏幕高度 - 导航栏高度
        nodeName: "",
        nodeListIndex: 0,
        typeValue: 0,
        tableData: [],
        archivesIds: "",
        departmentData: [],
        props: {
          children: 'next',
          label: 'name',
          value: 'id'
        },
        dialogVisible: false,
        dialogVisible2: false,
        form: {},
        nowArchiveDefectList: [],
        nowNode: undefined,
        nowItem: undefined,
        nowAction: undefined,
        nowArchive: {name: ''},
        nodeTypeList: [
          {
            name: '自定义',
            value: 0
          },
          {
            name: '现场交底',
            value: 1
          },
          {
            name: '巡检',
            value: 2
          },
          {
            name: '审批',
            value: 3
          }
        ],
        arAchiveList: undefined, //台账设备列表
        getArchive: true, //默认显示加载的台账设备
        filterText: '',
        nowCheckNodes: [],
        nodeArchives: [0],
        watchnodeList: [],
        standingBookId: [],
        tableDatAarchivesIds: []
      };
    },
    created () {

    },
    mounted () {
      this.$store.archivesStore.commit('getArchivesTree');
      this.departmentFindAllUserFun()

    },
    destroyed () {},
    computed: {
      nowIsFlag () {
        return this.isImport
      },
      nowUnit () {
        return this.$store.unitStore.state.nowUnit;
      },
      nodeList () {
        this.watchnodeList=this.nowFlow==undefined? []:this.nowFlow.next
        return this.nowFlow==undefined||JSON.stringify(this.nowFlow)==="{}"? []:this.nowFlow.next;
      },
      getArchiveDefectList: {
        get () {
          if(!isempty(this.nowFlow)&&!isempty(this.nowFlow.next)) {
            // console.log("测试",this.nowFlow);
            let nowNode=this.nowFlow.next.filter(item => {
              return item.nodeType==2;
            });
            this.clickArchive(nowNode[0].next[0]);
            return nowNode[0].next;
          } else {
            return [];
          }
        },
        set (val) {
          return [];
        }
      },
      itemList () {
        return this.nowNode==undefined? []:this.nowNode.next;
      },
      actionList () {
        if(this.nowItem==undefined) {
          return [];
        }
        for(var i=0,len=this.nowItem.next.length;i<len;i++) {
          var item=this.nowItem.next[i];
          item.valueTypeName=this.$store.enumStore.getters.getValueTypeNameByValueType(item.valueType);
        }
        return this.nowItem.next;
      },
      userTree () {
        return this.$store.userStore.getters.getUnitUserTree;
      },
      archiveTree () {
        return [this.$store.archivesStore.state.archivesTree];
      },
      // nowNodeUserName() {

      //   if (this.nowNode == undefined) {
      //     return '';
      //   }
      //   if (isempty(this.nowNode.nodeUsers)) {
      //     return '点击选择负责人';
      //   }
      //    this.nowNode.nodeUsers =   JSON.parse(JSON.stringify(this.nowNode.nodeUsers).replace(/name/g, 'userName'))

      //   return this.nowNode.nodeUsers[0].hasOwnProperty('username') ? this.nowNode.nodeUsers[0].username : this.nowNode.nodeUsers[0].userName;
      // },
      nowNodeArchivesName () {
        // console.log("点击选择台账设备",this.nowCheckNodes);
        if(this.nowCheckNodes.length==0) {
          return '点击选择台账设备';
        }
        return this.nowCheckNodes[0].name
      },
      autoCheck () {
        return this.nowNode!=undefined? this.nowNode.nodeType:0;
      },
      priorityMatch () {
        return this.$store.orderGroupStore.state.priorityMatch;
      }
    },
    watch: {
      watchnodeList (val) {
        // console.log("侦听器科技比较好",val);
        if(val!=undefined) {


          if(val.length!=0) {
            this.nodeList_fn(val[this.nodeListIndex],this.nodeListIndex)
          }
        }
      },
      filterText (val) {
        this.$refs.tree.filter(val);
      },
      nodeList (nv,ov) {
        if(nv==undefined||nv.length==0) {
          this.nowNode=undefined;
          return;
        }
        //if(nv.length > 0) {
        if(nv.length==1) {
          this.nowNode=nv[0];
          // this.$refs.scheduleAxisBean.nowItem = nv[0];
        } else if(nv.length>1) {
          this.nowNode=nv[nv.length-1];
          // this.$refs.scheduleAxisBean.nowItem = nv[nv.length - 1];
        }
      },
      itemList (nv,ov) {
        if(nv==undefined||nv.length==0) {
          this.nowItem=undefined;
          return;
        }
        if(nv.length>0) {
          this.nowItem=nv[0];
        }
      },
      nowNode (nv,ov) {
        this.nowArchiveDefectList=[];
        // 节点类型为巡检需检查台账设备选择情况
        if(isempty(nv)||isempty(nv.nodeType)) {
          return;
        }
        if(nv.nodeType==2) {
          if(!isempty(nv.next)) {
            if(nv.hasOwnProperty('archivesIds')&&!isempty(nv.archivesIds)) {
              this.nowArchive=copy(nv.archivesIds[0]);
            }
          }
        }
      },
      nowArchive (nv,ov) {
        this.getNowArchiveDefectList();
      },
      userTree (nv,ov) {},
      nodeName (val) {
        this.nodeList[this.nodeListIndex].nodeName=val
        // console.log("this.nodeList",this.nodeList[this.nodeListIndex]);

      },
      typeValue (val) {
        //  console.log("侦听器",this.tableData);
        //  this.tableData =  []
        this.nodeList[this.nodeListIndex].nodeType=val

      },
      nodeArchives (val) {
        // console.log("树形",val);
        this.getTableList(val)
      },
      nowOrderGroup (val) {
        // console.log("分组类型侦听器1234",val);
        this.nodeTypeList[2].name=val.name
        // this.tableData = []
      }
    },
    methods: {


      //抄送人
      nodeClick (val) {
        // console.log("巴黎",SelectedObj);
        // this.participants  = data
        // if(data.length == 0){
        //            this.userName = '请选择抄送人'
        // }else {
        // 	this.userName  = this.participants.map(item => item.username).join(' , ')
        // }
        // this.nowNode = val
        this.nowNodeUserName=val.name
        this.nodeList[this.nodeListIndex].nodeUsers=[val.id]
        this.nodeList[this.nodeListIndex].nowNodeUserName=val.name


        // if(val.name == 'PcmUser'){

        // }else {
        //    this.nowNode = undefined
        //    this.nowNodeUserName = '请选择负责人'
        // }

      },
      nowAction_fn (row) {
        this.nowAction=row
      },
      pickerWorkFlow_fn () {
        this.$emit('pickerWorkFlow');
      },

      //获取部门
      departmentFindAllUserFun () {
        departmentFindAllUser().then(res => {
          // console.log("部门",res);
          if(res.code==200) {
            this.departmentData=res.data
            this.departmentData=JSON.parse(JSON.stringify(this.departmentData).replace(/departmentId/g,'id').replace(/userId/g,"id"))
            this.departmentData=JSON.parse(JSON.stringify(this.departmentData).replace(/departmentName/g,'name').replace(/userName/g,"name"))
            this.departmentData=JSON.parse(JSON.stringify(this.departmentData).replace(/users/g,'next'))

          }
        })
      },
      filterNode (value,data) {
        if(!value) return true;
        return data.name.indexOf(value)!==-1;
      },
      checkItem (item) {
        // this.nowNode = item;

        // console.log("item",item);
        if(item.entityName=="AppEquipmentArchives") {
          this.findDefectActionList_fn(item.id)
        }


      },
      findDefectActionList_fn (id) {
        // console.log("台账id",id);
        if(id=='') {
          return
        }
        var d={
          'standingBookId': id,
          'pageNum': 1,
          "pageSize": 100

        }
        findDefectActionList(d).then(res => {
          // console.log("数据",res);
          this.nodeList[this.nodeListIndex].archivesIds=[]
          this.tableData=res.data.content
          this.tableDatAarchivesIds.forEach(row => {
            // console.log("选中表格",row);
            this.$nextTick(() => {
              //默认选中
              this.$refs['multipleTable'].toggleRowSelection(this.tableData.find(item => {
                return row.id==item.id;  // 注意这里寻找的字段要唯一，示例仅参考
              }),true);
            })

          });
        })
      },

      //表格多选
      handleSelectionChange (val) {
        this.nodeList[this.nodeListIndex].archivesIds=val
        //  console.log("表格多选节点",this.nodeList[this.nodeListIndex]);
      },
      addUsers () {
        var nodeUsers=[];
        if(this.nowNode!=undefined&&this.nowNode.hasOwnProperty('nodeUsers')&&!isempty(this.nowNode.nodeUsers)) {
          for(var i=0,len=this.nowNode.nodeUsers.length;i<len;i++) {
            var item=this.nowNode.nodeUsers[i];
            nodeUsers.push(item.hasOwnProperty('userId')? item.userId:item.id);
          }
        }

        // this.$dialogMethod.openSingleItemDialog('节点负责人', this.userTree, nodeUsers, respon => {
        //   this.$set(this.nowNode, 'nodeUsers', respon);
        // });
        this.$dialogMethod.openSingleItemDialog('节点负责人',this.departmentData,nodeUsers,respon => {
          this.$set(this.nowNode,'nodeUsers',respon);
          console.log("负责人",respon);
        });
      },
      // handleCheckChange(data, checked, indeterminate) {
      //   let nowCheckNodes = this.$refs.tree.getCheckedNodes()
      //   this.nowCheckNodes = 
      //     nowCheckNodes.filter(item => {
      //       return item.entityName == 'AppEquipmentArchives';
      // })
      // console.log("this.nowCheckNodes",this.nowCheckNodes);
      // },
      //树形结构选中节点
      currentChecked (nodeObj,SelectedObj) {
        // console.log(6848545654);
        // console.log("数据",this.nodeList);
        // console.log("下标",this.nodeListIndex);
        this.nodeList[this.nodeListIndex].next=[]
        this.nowCheckNodes=
          SelectedObj.checkedNodes.filter(item => {
            return item.entityName=='AppEquipmentArchives';
          })
        this.nodeList[this.nodeListIndex].archivesIds=this.nowCheckNodes
        // console.log(" this.nowCheckNodes", this.nowCheckNodes);
        //  console.log("索引",this.nodeList[this.nodeListIndex].archivesIds);
        this.tableData=[]
        // if(this.nowCheckNodes.length != 0){
        //   this.nowCheckNodes.forEach(item => {
        //       this.$api.workDefectApi.findDefectListByArchivesId(item.id, respon => {
        //         // this.nowArchiveDefectList = respon[0].defectList;
        //         this.tableData.push(respon[0])
        //         // this.nodeList[this.nodeListIndex].next.push(respon[0])
        //       });
        //   })
        //    if(this.tableData.length != 0){
        //     this.addArchives()
        //    }
        // }

      },
      //获取台账列表数据
      getTableList (val) {
        // this.tableData = []
        //  val.forEach(item => {
        //           this.$api.workDefectApi.findDefectListByArchivesId(item, respon => {
        //             this.tableData.push(respon[0])
        //           });
        //       })
      },
      addArchives () {
        this.dialogVisible=false
        this.getArchive=false

        this.$set(this.nowNode,'archivesIds',this.nowCheckNodes)



        if(this.nowNode.archivesIds.length==0) {
          this.nowArchiveDefectList=[]
        }
        this.nowArchive=isempty(this.nowCheckNodes)? {}:this.nowCheckNodes[0]
      },
      getNowArchiveDefectList () {
        if(isempty(this.nowArchive)) {
          this.nowArchiveDefectList=[];
          return;
        }
        this.$api.workDefectApi.findDefectListByArchivesId(this.nowArchive.id,respon => {
          this.nowArchiveDefectList=respon[0].defectList;
        });
      },
      clickArchive (data) {
        if(isempty(data)) {
          this.nowArchiveDefectList=[];
          return;
        }
        this.nowArchive=data;
        this.$api.workDefectApi.findDefectListByArchivesId(data.linkObject,respon => {
          this.nowArchiveDefectList=respon[0].defectList;
        });
      },
      getAllUserList (list,userIds) {
        var resultList=[];
        for(var i=0,len=list.length;i<len;i++) {
          var item=list[i];
          if(item.type=='PcmUser') {
            if(userIds.includes(item.id)) {
              resultList.push(item);
            }
          } else {
            //递归找下级
            resultList.addAll(this.getAllUserList(item.next,userIds));
          }
        }
        return resultList;
      },
      //新增节点
      addNode () {
        // if(this.nodeName == "" && this.nodeListIndex > 0){
        //   this.$dialogMethod.showMessage('请先填写此节点的名称!');
        //   return;
        // }
        if(this.nowFlow==undefined) {
          this.$dialogMethod.showMessage('请先选中或新增一个工作流!');
          return;
        }
        this.nodeName=""
        this.nodeList.push({
          nodeName: "",
          next: [],
          nodeUsers: [],
          archivesIds: [],
          nodeType: 0
        });
        this.nodeListIndex=this.nodeList.length-1
        this.typeValue=0

        if(this.nodeList.length==1) {
          this.nowNode=this.nodeList[0];
          // this.$refs.scheduleAxisBean.nowItem = this.nowNode;
        } else if(this.nodeList.length>1) {
          this.nowNode=copy(this.nodeList[this.nodeList.length-1]);

          // this.$refs.scheduleAxisBean.nowItem = this.nowNode;
        }

      },
      //点击节点
      nodeList_fn (item,index) {
        // console.log("切换点击",item);
        this.tableData=[]

        if(item.archivesIds) {
          this.tableDatAarchivesIds=item.archivesIds
          this.standingBookId=item.archivesIds.length==0? '':item.archivesIds[0].standingBookId
        }
        this.nodeArchives=[]
        this.typeValue=item.nodeType
        // console.log("类型", this.typeValue );
        this.nodeListIndex=index
        this.nodeName=item.nodeName
        this.nowNode=item;
        this.nowNodeUserName=item.nowNodeUserName
        if(this.typeValue==2) {
          if(this.nowOrderGroup.name!='巡检') {
            if(item.archivesIds.length==0&&item.archivesIds) {
              this.$nextTick(() => {
                //默认选中
                this.$refs['tree2'].setCurrentKey(null);
              })
            } else {

              this.$nextTick(() => {
                //默认选中
                this.$refs['tree2'].setCurrentKey(this.standingBookId);
              })

              this.findDefectActionList_fn(this.standingBookId)

            }


          } else {
            setTimeout(() => {

              this.$refs.tree.setCheckedKeys([]);
              // if(item.next.length == 0){
              //    item.archivesIds.forEach(item => {
              //       this.nodeArchives.push(item.id)
              //     })
              // }else {
              //      item.next.forEach(item => {
              //       this.nodeArchives.push(item.linkObject)
              //     })
              // }

            },500)
          }




        }


      },
      editNode (item) {
        this.$dialogMethod.openNomalInputDialog(
          '编辑节点',
          [
            {
              name: '节点名称',
              pkid: 'nodeName',
              defaultValue: item.nodeName
            }
          ],
          respon => {
            this.$set(item,'nodeName',respon.nodeName);
          }
        );
      },
      // 选择节点类型
      selectNodeType (item) {
        if(this.nowNode==undefined) {
          return;
        }
        this.$set(this.nowNode,'nodeType',item.value);
      },
      addItem () {
        if(this.nowNode==undefined) {
          this.$dialogMethod.showMessage('请先选中或新增一个节点!');
          return;
        }
        this.$dialogMethod.openNomalInputDialog(
          '新增操作项',
          [
            {
              name: '操作项名称',
              pkid: 'title'
            },
            {
              workTime: this.orderStartTime
            },
            {
              workTime: this.orderEndTime
            }
          ],
          respon => {
            this.itemList.push({
              title: respon.title,
              next: []
            });
            if(this.itemList.length==1) {
              this.nowItem=this.itemList[0];
            }
            // console.log("this.itemList",this.itemList);
            // console.log("this.nowItem",this.nowItem);
          }
        );
      },
      deleteItem (index) {
        // if (this.nowItem == undefined) {
        //   this.$dialogMethod.showMessage('请先选中一个操作项!');
        //   return;
        // }
        this.itemList.splice(index,1)

      },
      deletePro (index) {
        this.nodeList.splice(index,1)
        if(index<this.nodeList.length) {
          this.nodeList_fn(this.nodeList[index],index)
        } else {
          if(index!=0) {
            this.nodeList_fn(this.nodeList[index-1],index-1)
          }
        }


      },
      addAction () {
        if(this.nowItem==undefined) {
          this.$dialogMethod.showMessage('请先选中或新增一个操作项!');
          return;
        }
        this.$dialogMethod.openNomalInputDialog(
          '新增操作步骤',
          [
            {
              name: '操作步骤名称',
              pkid: 'actionName'
            },
            {
              name: '描述',
              pkid: 'content',
              type: 1
            },
            {
              name: '类型',
              pkid: 'valueType',
              type: 7,
              defaultValue: 0,
              dataList: this.$store.enumStore.state.valueTypeList
            }
          ],
          respon => {
            this.actionList.push({
              actionName: respon.actionName,
              content: respon.content,
              valueType: respon.valueType.value,
              valueTypeName: this.$store.enumStore.getters.getValueTypeNameByValueType(respon.valueType.value)
            });
            console.log("this.actionList",this.actionList);
          }
        );
      },
      deleteAction (row) {
        // if (this.nowAction == undefined) {
        //   this.$dialogMethod.showMessage('请先选中一个操作项!');
        //   return;
        // }
        this.actionList.remove(
          this.actionList.findIndex(item => {
            return item==row;
          })
        );
      },
      getData () {
        console.log("创建",this.nodeList);
        let d=this.nodeList.map(item => {
          var itemC=copy(item);
          itemC.nodeUsers=item.nodeUsers.map(user => {
            if(user.id) {
              return user.id;
            } else {
              return user.userId;
            }

          });
          if(isempty(item.archivesIds)) {
            itemC.archivesIds='';
          } else {
            itemC.archivesIds=item.archivesIds
              .map(archive => {
                return archive.id;
              })
              .join(',');
            this.archivesIds=itemC.archivesIds
          }
          return itemC;
        });
        return d
      },
      archivesIdsFun () {
        return this.archivesIds
      }
    }
  };
</script>

<style scoped lang="scss">
  .speed-progress {
    width: 100%;
    height: 36px;
    display: flex;
    align-items: center;
    margin: 20px 0px;

    .content {
      height: .65rem;
      max-width: 90%;
      display: flex;
      flex-shrink: 0;

      // overflow: scroll;
      /deep/.el-scrollbar__view {
        display: flex;
      }

      // or
      /deep/.el-scrollbar {
        /deep/.el-scrollbar__wrap {
          overflow-x: hidden;

        }
      }

      .item {
        display: flex;
        align-items: center;
        margin-right: 12px;
        flex-shrink: 0;
        height: .65rem;

        .item-num {
          font-size: 21px;
          width: 36px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          background-color: #F5F5F5;
          border-radius: 50%;
          color: #999;
          cursor: pointer;

          &.active {
            background-color: #368ED9;
            color: #fff;
          }

          &:hover i {
            display: block;
          }

          position: relative;
        }

        .item-name {
          margin: 0px 12px;
          cursor: pointer;
          color: #999999;

          &.item-name-active {
            color: #1a1a1a;
          }
        }

        .item-line {
          width: 0.96rem;
          height: 1px;
          background-color: #CCCCCC;
        }

        i {
          position: absolute;
          top: -6%;
          right: -.11rem;
          // color: red;
          font-size: 16px;
          font-weight: bold;
          color: #999;
          display: none;

          &:hover {
            font-size: 20px;
          }
        }
      }

    }

    /deep/.el-scrollbar__bar {
      bottom: 9px;
    }

    .add-btn {
      background-color: #F5F5F5;
      color: #999999;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      margin-left: 12px;
      font-size: 22px;
      width: 36px;
      height: 36px;
      line-height: 36px;

      cursor: pointer;

      &:hover {
        background-color: #409eff;
        color: #fff;
      }

      i {
        font-size: 24px;
      }
    }
  }

  /deep/.el-table th {
    background-color: #F5F5F5;
    color: #999;
  }

  /deep/.el-table__body tr.current-row>td {
    background-color: #CFE3FF !important;
  }

  .selectNodeValue {
    display: flex;
    margin-top: 4px;

    .selectNodeValue-input {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e6e6e6;
      padding-bottom: 20px;

      /deep/.el-input {
        width: 240px;
      }

      span {
        flex-shrink: 0;
      }
    }


  }

  .user-sle {
    position: relative;
    width: 240px;
    height: 36px;
    border-radius: 2px;

    .user-text {
      width: 100%;
      height: 36px;
      border: 1px solid #cccccc;
      border-radius: 2px;
      box-sizing: border-box;
      position: relative;
      // text-align: center;
      line-height: 36px;

      span {
        color: #999999;
        margin-left: 10px;
      }

      img {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 7px;
        transition: 0.3s;

        &.tran-img {
          transform: translateY(-50%) rotateZ(180deg);
        }
      }

    }

    .user-tree {
      position: absolute;
      width: 100%;
      background-color: #fff;
      padding-top: 8px;
      // top: 38px;
      z-index: 99;

      .user-tree-con {
        width: 100%;
        height: 100%;
        border: 1px solid #cccccc;
        box-sizing: border-box;
      }
    }
  }

  .account {
    width: 100%;
    height: 72%;
    margin-top: .3rem;
    display: flex;
    justify-content: space-between;

    .account-left {
      width: 25%;
      height: 100%;
      border-right: 1px solid #E6E6E6;

      .scroll {
        width: 100%;
        height: 100%;

        p {
          margin-left: .1rem;
        }

        /deep/.el-input__inner {
          margin: 10px;
          width: 80%;
        }
      }

      /deep/.el-tree-node__content:hover {
        background-color: #eaf4ff !important;
      }

      /deep/ .is-current>.el-tree-node__content {
        background-color: #add5ff !important;
      }

      /deep/.el-scrollbar .el-scrollbar__wrap {
        overflow-x: hidden;
      }

      /deep/.el-scrollbar__wrap .el-scrollbar__view {
        width: 100%;
        white-space: nowrap;
        display: inline-block;
      }
    }

    .account-right {
      width: 74%;
    }
  }

  /deep/.el-scrollbar__wrap {
    overflow-x: hidden !important;
  }

  .custom {
    display: flex;

    .custom-left {
      width: 240px;
      border-right: 1px solid #E6E6E6;
      padding: 20px 20px 10px 0px;
      box-sizing: border-box;

      /deep/.el-button {
        padding: 6px 10px;
      }

      .Files-top {
        padding-bottom: 20px;
        border-bottom: 1px solid #e6e6e6;
      }

      .titles {
        margin-left: .2rem;
        margin-bottom: .10rem;
        font-size: .15rem;
        color: #999999;
      }

      .left-list {
        // max-height: 300px;
        //  height: 85%;
        margin-top: 20px;

        .item {
          height: 72px;
          width: 100%;
          padding: 0px 12px 0px 14px;
          box-sizing: border-box;
          color: #1a1a1a;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: #666666;

          &:hover {
            i {
              display: block;
            }

            span {
              color: #1a1a1a;
            }


          }

          i {
            font-size: 20px;
            color: #999999;
            display: none;
          }

          &.active {
            background-color: #F3FAFF;

            border-left: 2px solid #409EFF;

            span {
              font-weight: bold;
              color: #368ED9;
            }
          }
        }
      }

      .left-btns {

        width: 100%;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;

        .ju-zhong {
          border-top: 1px solid #ebeef5;
          width: 90%;
          display: flex;
          height: 100%;
          // justify-content: center;
          align-items: center;
        }

        .add {
          margin: 0px .15rem;
          color: #409EFF;
          cursor: pointer;
          font-size: .15rem;
        }

        .del {
          color: #FF7765;
          cursor: pointer;
          font-size: .15rem;
        }

      }
    }

    .custom-right {
      width: 80%;
      padding: 20px 0px 0px 20px;
      box-sizing: border-box;

      .Files-top {
        padding-bottom: 20px;
        border-bottom: 1px solid #e6e6e6;
        margin-bottom: 20px;
      }

      .right-btns {
        padding: .16rem .1rem;
        // border-bottom: 1px solid #ebeef5;

        .add {
          margin-right: .15rem;
          color: #409EFF;
          cursor: pointer;
          font-size: .15rem;
        }

        .del {
          color: #FF7765;
          cursor: pointer;
          font-size: .15rem;
        }

      }
    }
  }

  .isCheck {
    background: skyblue;
    color: white;
  }

  .createNodeBody {
    color: #1a1a1a;
    // height: 86vh;
    // height: 86%;
    height: calc(100% - 150px);

    background-color: #fff;
    padding: 20px;
    overflow: hidden;
    box-sizing: border-box;
  }

  .createNodeBody>.createNodeBody-title {
    margin: .2rem 0px .2rem .1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .addItem {
    border-top: #cecece 1px dashed;
  }

  .addItem>span {
    cursor: pointer;
    padding: 0 20px;
    color: skyblue;
  }

  .addItem>span:hover {
    color: steelblue;
  }

  .nomal-table {
    border-collapse: collapse;
  }

  .nomal-table td,
  .nomal-table th {
    padding: 5px 2px;
    border-right: #cecece dashed 1px;
  }



  .selectArchives {
    padding: 0 10px;
    margin: 20px 0;
  }

  .archivesListContainer {
    min-height: 160px;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    border: solid 1px #e4e4e4;
    padding-bottom: 10px;
  }

  .archivesList {
    width: 200px;
    height: auto;
  }

  .archiveName {
    display: block;
    width: 100%;
    text-align: center;
    padding: 5px 0;
    border-bottom: solid 1px #e4e4e4;
    border-right: solid 1px #e4e4e4;
    border-radius: 4px;
  }

  .archiveNameSelected {
    background-color: #ecf5ff;
    color: #409eff;
  }

  .defectList {
    width: calc(100% - 220px);
    margin: 10px;
  }

  .defectMessageBox {
    border: solid 1px #e4e4e4;
    border-radius: 2px;
    padding: 10px 15px;
    margin-bottom: 10px;
    position: relative;
  }

  .defectMessageBox:hover {
    border-color: #0099ff;
  }

  .defectMessageBox>p {
    line-height: 28px;
  }

  .defectTitle {
    font-weight: bold;
  }

  .defectLabel {
    color: #cccccc;
    margin-left: 30px;
  }

  .defectLabel:first-child {
    margin: 0;
  }
</style>